// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tl-row-timestamp-wrapper[data-v-1c522d3c] {\n  position: relative;\n  display: inline-block;\n}\n.tl-row-timestamp[data-v-1c522d3c] {\n  position: absolute;\n  transform: translate(-210px, 0);\n  padding: 1.5rem;\n  width: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
